export default "__VITE_ASSET__BrPhD6I8__"